export const LANGUAGE_PACKS_LOADED = "languagePacks/loaded"
export const LANGUAGE_PACKS_ADDED = "languagePacks/added"
export const LANGUAGE_PACKS_DELETED = "languagePacks/deleted"
export const LANGUAGE_PACK_UPDATED = "languagePack/updated"
export const LANGUAGE_PACK_DELETED = "languagePack/deleted"
